<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="pictures_logo"><span class="Italic _idGenCharOverride-1"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2"> </span></p>
<p class="Dedication"><span class="Italic _idGenCharOverride-2">For Anne Herbert, </span></p>
<p class="Dedication _idGenParaOverride-1"><span class="Italic _idGenCharOverride-2">the woman who started the movement</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RandomActsKindness-3.vue?6167adc1